export default function useIntercom() {
	const { loadScript, scriptIsLoaded } = useScriptLoader()

	const openInterCom = () => {
		// @ts-ignore
		if (window && window?.Intercom) {
			// @ts-ignore
			window.Intercom('show')
		}
	}

	watch(
		scriptIsLoaded,
		e => {
			if (e) {
				const runtime = useRuntimeConfig()
				// @ts-ignore
				if (window && window?.Intercom) {
					// @ts-ignore
					window?.Intercom('boot', {
						app_id: runtime.public.intercomKey,
						hide_default_launcher: true,
						custom_launcher_selector: '#intercom_custom_btn'
					})
				}
			}
		},
		{ immediate: true }
	)

	onMount(() => {
		// This is to lazy load on first mount to improve performance
		resolve(
			() => {
				loadScript('/js/intercom.js')
				loadScript('https://widget.intercom.io')
			},
			ref(false),
			2000
		)
	})

	return {
		openInterCom
	}
}
